module.exports = __webpack_public_path__ + "img/register_image.d741c4aa.png";